export const CATEGORY_INFO_TOOLTIP_MESSAGE = `Las categorías diferencian tus gastos de ingresos`;
